import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import green from '@material-ui/core/colors/green';
import grey from '@material-ui/core/colors/grey';
import {useDispatch, useSelector} from "react-redux";
import {
  setTargetScopeAction,
} from "../../../actions";
import red from "@material-ui/core/colors/red";
import {bbScopeIcon} from "../../../util/bbHelpers";
import IconButton from "@material-ui/core/IconButton";

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  wrapper: {
    // margin: theme.spacing(1),
    position: 'relative',
  },
  color1: {
    backgroundColor: green[500],
    color: grey[50],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  color2: {
    backgroundColor: red[500],
    color: grey[50],
    '&:hover': {
      backgroundColor: red[700],
    },
  },
  fabProgress: {
    color: green[500],
    position: 'absolute',
    top: -7,
    left: -7,
    zIndex: 1,
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -16,
    marginLeft: -17,
  },
});

const ToggleButton = (props) => {

  const {classes, customerId, targetId, targetProperty, flipColorLogic = false} = props;
  const {customers, scopeTogglesLoading, scopeTogglesFail} = useSelector(({customer}) => customer);
  const [localLoading, setLocalLoading] = useState(false);

  const targets = customers ? customers[customerId] ? customers[customerId].targets : null : null;
  const target = targets ? targets[targetId] ? targets[targetId] : null : null;
  const targetPropertyState = target
      ? target[targetProperty]
          ? target[targetProperty] === "1"
              ? true
              : target[targetProperty] === "0"
                  ? false
                  : null
          : null
      :null;

  const dispatch = useDispatch();

  useEffect(() => {
    // console.log("printing a user toggle switch for user, ", userId, user);
    //check for this customer and this target's loader.
    const isLoading = scopeTogglesLoading[customerId] ? scopeTogglesLoading[customerId][targetId] ? scopeTogglesLoading[customerId][targetId] : null : null;
    const isError = scopeTogglesFail[customerId] ? scopeTogglesFail[customerId][targetId] ? scopeTogglesFail[customerId][targetId] : null : null;

    if (!isLoading || isError) {
      setLocalLoading(false);
    }
  }, [scopeTogglesLoading, customerId, scopeTogglesFail, targetId]);

  const handleButtonClick = () => {
    if (!localLoading) {
      if (target) {
        switch (targetProperty) {
          case "OutOfScope":
            setLocalLoading(true);
            dispatch(setTargetScopeAction({"customerId": customerId, "targetId": targetId, "newScopeStatus": !targetPropertyState}));
            break;

          default:
            break;
        }
      }
    }
  };

  // const buttonClassname = classNames({
  //   // [classes.color1]: flipColorLogic? !userPropertyState : userPropertyState,
  //   [classes.color2]: flipColorLogic? targetPropertyState : !targetPropertyState,
  // });

  return (
      <div className={classes.root}>
        <div className={classes.wrapper}>
            {/*<div className={classes.wrapper}>*/}
            {/*  <Fab color="default" className={buttonClassname} onClick={(event) => handleButtonClick(event)}>*/}
            {/*    {userPropertyState ? <StopSharpIcon/> : <PlayArrowSharpIcon/>}*/}
            {/*  </Fab>*/}
            {/*  {localLoading && <CircularProgress size={68} className={classes.fabProgress}/>}*/}
            {/*</div>*/}
            {/*<div className={classes.wrapper}>*/}
            {/*  <Button*/}
            {/*    variant="contained"*/}
            {/*    color="default"*/}

            {/*  >*/}
            {/*    /!*{customer ? isStromboliActive ? "Stop Continuous Attacks" : "Start Continuous Attacks" : "Loading..."}*!/*/}
            {/*    {propertyDisplayName}*/}
            {/*  </Button>*/}
            {/*  {localLoading && <CircularProgress size={24} className={classes.buttonProgress}/>}*/}
            {/*</div>*/}
            {localLoading && <CircularProgress size={34} disableShrink className={classes.buttonProgress}/>}
            {/*<Badge*/}
            {/*    // color={color}*/}
            {/*    // className={buttonClassname}*/}
            {/*    disabled={localLoading}*/}
            {/*    onClick={(event) => handleButtonClick(event)}*/}
            {/*    type={"Button"}*/}
            {/*>*/}
          <IconButton
              // variant="outlined"
              // color="default"
              className={classes.button}
              onClick={() => handleButtonClick()}
              disabled={localLoading}
          >
            {bbScopeIcon(targetPropertyState)}
          </IconButton>

            {/*</Badge>*/}
            </div>

          </div>
  );

}

ToggleButton.propTypes = {
  classes: PropTypes.object.isRequired,
  customerId: PropTypes.string.isRequired,
  targetId: PropTypes.string.isRequired,
  targetProperty: PropTypes.string.isRequired,
  // propertyDisplayName: PropTypes.string.isRequired,
  flipColorLogic: PropTypes.bool,
};

export default withStyles(styles)(ToggleButton);